import i18n, { InitOptions } from 'i18next';
import Backend, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const backendOptions: InitOptions<HttpBackendOptions> = {
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
  },
  react: {
    useSuspense: false,
  },
  ns: ['translation', 'toast', 'global', 'nav', 'admin', 'enum'],
  defaultNS: 'translation',
  debug: false,
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false,
  },
};

export const initI18n = async () => {
  const instance = i18n.createInstance();
  instance.use(Backend).use(initReactI18next);

  if (import.meta.env.MODE !== 'production') {
    const { HMRPlugin } = await import('i18next-hmr/plugin');
    instance.use(new HMRPlugin({ vite: { client: true } }));
  }

  await instance
    .init<HttpBackendOptions>(backendOptions)
    .catch((e) => console.error(e));

  return instance;
};

const createSyncInstance = () => {
  const instance = i18n.createInstance();
  instance.use(Backend).use(initReactI18next);
  instance.init(backendOptions);
  return instance;
};

let mainI18n: typeof i18n;

if (process.env.NODE_ENV === 'test' || typeof window === 'undefined') {
  mainI18n = createSyncInstance();
} else {
  mainI18n = createSyncInstance();

  initI18n()
    .then((instance) => {
      if (import.meta.env.MODE !== 'production') {
        import('i18next-hmr/plugin').then(({ HMRPlugin }) => {
          instance.use(new HMRPlugin({ vite: { client: true } }));
        });
      }
    })
    .catch(console.error);
}

export default mainI18n;
